import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import Link from "components/elements/Link"

type Props = {
  onRetry: () => void
  message?: string
  centered?: boolean
}

// Inline fallback for one section of a page. The rest of the page keeps
// working, so it stays quiet: muted text, no red.
const PanelErrorView = ({
  onRetry, message = "This section couldn’t be loaded.", centered = false,
}: Props) => {
  const content = (
    <Flex role="alert" alignItems="center" gap={2} py={2} color="gray.600" fontSize="md" fontWeight="normal">
      <Icon icon="alert" color="gray.400" size={4} />
      <Text>{message}</Text>
      <Link as="button" type="button" onClick={onRetry} fontSize="md">Try again</Link>
    </Flex>
  )

  if (!centered) return content

  return (
    <Flex h="full" minH="20rem" align="center" justify="center" p={6}>
      {content}
    </Flex>
  )
}

export default PanelErrorView
